import { GetStepPath, Step } from "../../../../types/Step";
import { View, ViewKeyMap } from "../../../../types/Views";
import IUserEvent, { UserEventType } from "../../../types/IUserEvent";
import {
  GoogleTagsManagerStepArrivalEvent,
  GoogleTagsManagerViewArrivalEvent,
  IGoogleTagsManagerEvent
} from "./GoogleTagsManagerEvents";

interface IGoogleTagsManagerEventFactory {
  readonly buildEvent: (userEvent: IUserEvent<unknown>) => IGoogleTagsManagerEvent | null;
}

const googleTagsUserEventTypesMap: Partial<Record<UserEventType, string>> = {
  [UserEventType.StepArrival]: "obx_step_landed",
  [UserEventType.ViewArrival]: "obx_view_landed"
};

const gtmStepNameOverrides: Partial<Record<Step, string>> = {
  [Step.medicalGeneral]: "mq_1",
  [Step.medicalPacemaker]: "mq_2",
  [Step.medicalRadiation]: "mq_3",
  [Step.medicalDiabetic]: "mq_4",
  [Step.medicalAll]: "mq_all"
};

export class GoogleTagsManagerEventFactory implements IGoogleTagsManagerEventFactory {
  buildEvent(userEvent: IUserEvent<unknown>): IGoogleTagsManagerEvent | null {
    const eventName = googleTagsUserEventTypesMap[userEvent.type];
    if (!eventName) return null;

    switch (userEvent.type) {
      case UserEventType.StepArrival: {
        const step = userEvent.value as Step;
        const stepName = gtmStepNameOverrides[step] ?? Step[step];
        return new GoogleTagsManagerStepArrivalEvent(
          eventName,
          stepName,
          `${window.location.origin}${GetStepPath(step)}`
        );
      }
      case UserEventType.ViewArrival: {
        const view = userEvent.value as View;
        const uri = Object.values(ViewKeyMap).find(v => v.key === view)?.uri ?? "";
        return new GoogleTagsManagerViewArrivalEvent(eventName, view, `${window.location.origin}${uri}`);
      }
      default:
        return null;
    }
  }
}

export default IGoogleTagsManagerEventFactory;
